<template>
  <el-container @keyup.enter.native="login" class="login">
    <el-header class="login__header">
      <img class="login__header__logo" src="@/assets/img/logo.png" alt="" />
      <span class="login__header__text">登录</span>
    </el-header>
    <el-main class="login__main">
      <div class="login__box">
        <el-tabs v-model="loginType">
          <el-tab-pane label="密码登录" name="password">
            <div class="login__box__title">密码登录</div>
            <el-form :model="accountData" :rules="accountRules" ref="pwdForm">
              <el-form-item prop="userName">
                <el-input
                  v-model="accountData.userName"
                  clearable
                  key="userName"
                  name="userName"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  v-model="accountData.password"
                  clearable
                  key="password"
                  name="password"
                  placeholder="请输入密码"
                  show-password
                ></el-input>
              </el-form-item>
            </el-form>
            <el-button
              :disabled="!userNameLoginAble"
              class="login__box__submit"
              type="primary"
              size="medium"
              @click="userNameLogin"
            >
              登录
            </el-button>
          </el-tab-pane>
          <el-tab-pane label="验证码登录" name="verifyCode">
            <div class="login__box__title">验证码登录</div>
            <el-form :model="mobileData" :rules="pwdRules" ref="phoneForm">
              <el-form-item prop="mobile">
                <el-input
                  v-model="mobileData.mobile"
                  clearable
                  key="mobile"
                  name="accountNo"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>
              <el-form-item prop="verifyCode">
                <el-input
                  v-model="mobileData.verifyCode"
                  clearable
                  key="password"
                  name="password"
                  placeholder="请输入验证码"
                >
                  <template #append>
                    <span
                      :style="{
                        cursor: sendverifyCodeAble ? 'pointer' : 'not-allowed'
                      }"
                      @click="getVerifyCode"
                      class="pointer"
                      v-if="second === 0"
                    >
                      {{ sendOption.isReSend ? '重新发送' : '获取验证码' }}
                    </span>
                    <span class="not-allowed center" v-else>{{ second }}S</span>
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
            <el-button
              :disabled="!verifyCodeLoginAble"
              class="login__box__submit"
              type="primary"
              size="medium"
              @click="verifyCodeLogin"
            >
              登录
            </el-button>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-main>
    <el-footer class="login__footer">
      <MainFooter />
    </el-footer>
  </el-container>
</template>

<script>
import MainFooter from '@/components/MainFooter/index.vue';
import * as api from '@/services';
import { mapState, mapActions } from 'vuex';
export default {
  components: {
    MainFooter
  },
  watch: {
    loginType() {
      this.resetPhoneForm();
      this.resetPwdForm();
    }
  },
  computed: {
    userNameLoginAble() {
      return this.accountData.userName !== '' && this.accountData.password !== '';
    },
    verifyCodeLoginAble() {
      return this.mobileData.mobile !== '' && this.mobileData.verifyCode !== '';
    },
    sendverifyCodeAble() {
      const pattern = /^1[1234567890]\d{9}$/;
      return pattern.test(this.mobileData.mobile);
    },
    ...mapState('USER', {
      userInfo: (state) => state.userInfo
    })
  },
  mounted() {
    Telescope.trackPage({
      trackId: 'zyb2bpc-page-dlzcy-dlyB2B'
    });
  },
  data() {
    const validatorPhone = (rule, value, callback) => {
      if (value === '') {
        this.$message.error('请输入手机号');
        callback(new Error('请输入手机号'));
      } else {
        callback();
      }
    };
    const validatorPwd = (rule, value, callback) => {
      if (value === '') {
        this.$message.error('请输入密码');
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    const validatorVerifyCode = (rule, value, callback) => {
      if (value === '') {
        this.$message.error('请输入验证码');
        callback(new Error('请输入验证码'));
      } else {
        callback();
      }
    };
    return {
      loginType: 'password',
      accountData: {
        userName: '',
        password: ''
      },
      accountRules: {
        // 自定义校验方法是因为输入为空时需要message提示(账号、密码)
        userName: [
          { validator: validatorPhone, trigger: 'blur' },
          { min: 11, max: 11, message: '手机号长度为11个数字', trigger: 'blur' },
          { message: '手机号格式不正确', pattern: /^1[1234567890]\d{9}$/, trigger: 'blur' }
        ],
        password: [{ validator: validatorPwd, trigger: 'blur' }]
      },
      mobileData: {
        mobile: '',
        verifyCode: ''
      },
      pwdRules: {
        // 自定义校验方法是因为输入为空时需要message提示(账号、密码)
        mobile: [
          { validator: validatorPhone, trigger: 'blur' },
          { min: 11, max: 11, message: '手机号长度为11个数字', trigger: 'blur' },
          { message: '手机号格式不正确', pattern: /^1[1234567890]\d{9}$/, trigger: 'blur' }
        ],
        verifyCode: [{ validator: validatorVerifyCode, trigger: 'blur' }]
      },
      sendOption: {
        duration: 60,
        isReSend: false
      },
      second: 0
    };
  },
  methods: {
    login() {
      if (this.loginType === 'password') {
        this.userNameLogin();
      } else if (this.loginType === 'verifyCode') {
        this.verifyCodeLogin();
      }
    },
    ...mapActions('USER', ['getUserInfo']),
    async judgeAuthInfo() {
      await this.getUserInfo();
      const pcEntrance = await api.login.pcEntrance();
      if (!pcEntrance.drugShopEntrance) {
        this.$message.error('请联系对应销售，开通账户');
        return;
      }
      if (!(this.userInfo.userInfoVO?.roleList || []).includes('buyers')) {
        this.$router.replace('/identify/status');
      } else {
        // 协议签署状态;
        const res = await api.aggrement.queryUserAgreementSignStatus({
          agreementType: 'B2B_PURCHASER_AGREEMENT'
        });
        if (res === 0) {
          this.$router.replace('/identify/aggrement');
        } else {
          this.$router.push('/mallHomePage/all');
        }
      }
    },
    // 账号密码登录
    userNameLogin() {
      Telescope.trackEvent({
        trackId: 'zyb2bpc-event-dlzcy-dlydjdlanB2B'
      });

      this.$refs.pwdForm.validate(async (valid) => {
        if (valid) {
          await api.login.userNameLogin(this.accountData);
          this.judgeAuthInfo();
        }
      });
    },
    // 验证码登录
    verifyCodeLogin() {
      Telescope.trackEvent({
        trackId: 'zyb2bpc-event-dlzcy-dlydjdlanB2B'
      });

      this.$refs.phoneForm.validate(async (valid) => {
        if (valid) {
          await api.login.verifyCodeLogin(this.mobileData);
          this.judgeAuthInfo();
        }
      });
    },
    // 获取验证码
    async getVerifyCode() {
      if (!this.sendverifyCodeAble) return;
      const reseult = await api.login.getVerifyCode({
        mobile: this.mobileData.mobile
      });
      // 发送成功才开始处理
      if (reseult) {
        this.$message({
          type: 'success',
          message: '短信验证码已发送至您的手机，请注意查收'
        });
        this.countdown(this.sendOption.duration);
      }
    },
    // 验证码倒计时
    countdown(duration) {
      this.second = duration;
      let timer = setInterval(() => {
        this.second -= 1;
        if (this.second < 1) {
          this.sendOption.isReSend = true;
          clearInterval(timer);
        }
      }, 1000);
    },
    // 重置表单
    resetPhoneForm() {
      this.$refs.phoneForm.resetFields();
      this.accountData.userName = '';
      this.accountData.password = '';
    },
    resetPwdForm() {
      this.$refs.pwdForm.resetFields();
      this.mobileData.mobile = '';
      this.mobileData.verifyCode = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  height: 100%;
  min-height: 410px;
  position: relative;
  &__header {
    display: flex;
    align-items: center;
    height: 68px;

    &__logo {
      width: 110px;
      height: 32px;
      vertical-align: middle;
    }
    &__text {
      position: relative;
      margin-left: 48px;
      font-size: 18px;
      font-weight: 400;
      color: #262626;
      line-height: 32px;
      vertical-align: middle;
      &::before {
        content: '';
        width: 1px;
        height: 100%;
        position: absolute;
        top: 0;
        left: -24px;
        background: #eeeeee;
      }
    }
  }
  &__main {
    background: url('../assets/login-bg.png') no-repeat;
    background-size: cover;
    padding: unset !important;
  }
  &__box {
    position: absolute;
    width: 380px;
    height: 410px;
    background: #ffffff;
    right: 160px;
    top: 50%;
    transform: translateY(-50%);
    &__title {
      margin-bottom: 28px;
      font-size: 24px;
      font-weight: 500;
      color: #333333;
      line-height: 1;
    }
    &__submit {
      width: 100%;
      padding: 12px 0;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      line-height: 1;
    }
    ::v-deep .el-tab-pane {
      height: 363px;
      width: 100%;
      padding: 40px 50px;
    }
    ::v-deep .el-tabs__header {
      margin: 0;
    }
    ::v-deep .el-tabs__item {
      text-align: center;
      width: 190px;
      height: 48px;
      font-size: 14px;
      font-weight: 400;
      color: #555555;
      line-height: 48px;
    }
    ::v-deep .is-active {
      color: #1e8dff;
    }
    ::v-deep .el-input-group__append {
      width: 115px;
      text-align: center;
    }
  }
  &__footer {
    // position: absolute;
    // height: 114px !important;
    // bottom: 0;
    // left: 0;
    // right: 0;
    // padding: 33px 0;
    // text-align: center;
    // font-size: 12px;
    // font-weight: 400;
    // color: #8c8c8c;
    // line-height: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 120px !important;
    background-color: #fff;
  }
  .not-allowed {
    cursor: not-allowed;
  }
}
</style>
